import React, { useState } from "react";
import { Navigate, Link, useLocation, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase.js";
import { useAuth } from "../auth/AuthContext.jsx";
import Seo from "../components/Seo.jsx";
import "../admin.css";
import "../nav.css";

function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loading, user } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const redirectPath = location.state?.from?.pathname || "/admin";

  if (!loading && user) {
    return <Navigate replace to={redirectPath} />;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    try {
      setSubmitting(true);
      setError("");
      await signInWithEmailAndPassword(auth, email, password);
      navigate(redirectPath, { replace: true });
    } catch (loginError) {
      setError(loginError.message || "Login failed. Check your Firebase email/password account.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-layout">
      <Seo noindex pathname="/login" title="Admin Login | Pentagon Properties" />
      <header className="custom-navbar admin-navbar">
        <div className="custom-container admin-navbar__container">
          <Link className="custom-brand" to="/">
            Pentagon Properties
          </Link>
          <div className="admin-navbar__actions">
            <Link className="admin-navbar__link" to="/">
              Home
            </Link>
          </div>
        </div>
      </header>

      <main className="admin-login">
        <section className="admin-login__shell">
          <div className="admin-login__card">
            <p className="admin-page__eyebrow">Secure Access</p>
            <h1>Admin Login</h1>
            <p className="admin-page__subtitle">
              Sign in - For technical support please contact Ian.
            </p>

            <form className="admin-login__form" onSubmit={handleSubmit}>
              <label className="admin-input-group">
                <span>Email</span>
                <input
                  autoComplete="email"
                  className="form-control"
                  onChange={(event) => setEmail(event.target.value)}
                  required
                  type="email"
                  value={email}
                />
              </label>

              <label className="admin-input-group">
                <span>Password</span>
                <input
                  autoComplete="current-password"
                  className="form-control"
                  onChange={(event) => setPassword(event.target.value)}
                  required
                  type="password"
                  value={password}
                />
              </label>

              {error ? <p className="admin-feedback admin-feedback--error">{error}</p> : null}

              <button className="btn btn-primary btn-xl text-uppercase" disabled={submitting} type="submit">
                {submitting ? "Signing In..." : "Sign In"}
              </button>
            </form>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Login;
